import { render } from "./cv.vue?vue&type=template&id=31d36e2c&scoped=true"
import script from "./cv.vue?vue&type=script&lang=js"
export * from "./cv.vue?vue&type=script&lang=js"

import "./cv.vue?vue&type=style&index=0&id=31d36e2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d36e2c"]])

export default __exports__